import { cents, MoneyError } from "./money.js";
// D, 7 October 2026: quantity times price is the amount. Prices can need more than
// two decimals when an invoice amount is divided between units; totals stay in cents.
function quantityUnits(quantity) {
    const scaled = Math.round(quantity * 1000);
    if (!Number.isFinite(quantity) || quantity <= 0 || scaled <= 0 || !Number.isSafeInteger(scaled) || Math.abs(quantity * 1000 - scaled) > 1e-6)
        throw new MoneyError("Use a positive quantity with at most three decimals");
    return BigInt(scaled);
}
export function unitPriceText(value) {
    const text = value.trim();
    if (text.includes(",") && !/^\d{1,3}(,\d{3})+(\.\d{1,6})?$/.test(text))
        throw new MoneyError("Check the price");
    const clean = text.replace(/,/g, "");
    if (!/^\d+(\.\d{1,6})?$/.test(clean))
        throw new MoneyError("Use a price with at most six decimals");
    const [whole = "0", fraction = ""] = clean.split(".");
    let decimals = fraction.padEnd(2, "0");
    while (decimals.length > 2 && decimals.endsWith("0"))
        decimals = decimals.slice(0, -1);
    return `${BigInt(whole)}.${decimals}`;
}
export function lineAmountFromPrice(price, quantity) {
    const [whole = "0", fraction = ""] = unitPriceText(price).split(".");
    const micros = BigInt(whole) * 1000000n + BigInt(fraction.padEnd(6, "0"));
    const exact = micros * quantityUnits(quantity);
    return cents(Number((exact + 5000000n) / 10000000n));
}
/** Display only: do not replace a recorded line total with a rounded unit price. */
export function priceFromLineAmount(total, quantity) {
    if (total < 0)
        throw new MoneyError("Use a non-negative line amount");
    const divisor = quantityUnits(quantity) * 100n;
    const micros = (BigInt(total) * 1000000000n + divisor / 2n) / divisor;
    return unitPriceText(`${micros / 1000000n}.${String(micros % 1000000n).padStart(6, "0")}`);
}
//# sourceMappingURL=unit-price.js.map